const Search = (props) => {
  const { valueSearch } = props;
  return (
    <div style={{ marginBottom: "21px", display: "flex" }}>
      <input type="text" onChange={valueSearch} />
    </div>
  );
};
export default Search;
